/** `world_date` and temporal fields: read-only here (the calendar and the When pill own them). */
import type { FieldDefV1 } from '@codex/contracts';

export const WORLD_DATE_NOTE = 'Dates arrive with the calendar.';
export const TEMPORAL_NOTE = 'Dated values are edited from the When pill.';

/** Whether a field is edited elsewhere. */
export const isDatedField = (field: FieldDefV1): boolean =>
  field.kind === 'world_date' || field.temporal;

export function DatedReadOnly({ field }: { field: FieldDefV1 }) {
  return (
    <div className="cx-pills__field">
      <span className="cx-pills__label">{field.label}</span>
      <span className="cx-pills__hint">
        {field.kind === 'world_date' ? WORLD_DATE_NOTE : TEMPORAL_NOTE}
      </span>
    </div>
  );
}
